__turbopack_context__.v({
  "navBackground": "nav-animation-module__I7HTMq__navBackground",
  "navContainer": "nav-animation-module__I7HTMq__navContainer",
  "navItem": "nav-animation-module__I7HTMq__navItem",
});
